{
  "version": 1,
  "asset_id": "15e7d510-a58e-4718-bf5b-2bdbae4ec889",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/15e7d510-a58e-4718-bf5b-2bdbae4ec889/cert-2.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/15e7d510-a58e-4718-bf5b-2bdbae4ec889/cert-2.png",
  "original_filename": "cert-2.png",
  "size": 27794,
  "content_type": "image/png",
  "created_at": "2026-07-13T04:09:56Z"
}
